import {SListTabs} from "shj-components";

import CustomParameter from "./customParameter";
import {useEffect, useState} from "react";
import {getProductEnums} from "@/services/product.ts";
import {isEmpty} from "lodash-es";
import SpaceParameter from "./spaceParameter";

const ParameterManage = () => {

  const [tabList, setTabList] = useState([])
  const [activeKey, setActiveKey] = useState('')

  useEffect(() => {
    getTab()
  }, []);

  useEffect(() => {
    if(!isEmpty(tabList)) setActiveKey('define')
  }, [tabList]);

  const getTab = async () => {
    const tabEnum = await getProductEnums('com.shj.saas.plus.product.enums.ArgManageTypeFlagEnum')
    const list = tabEnum?.reduce((res, item) => {
      const item_ = {
        key: item.key,
        label: item.description,
        children: <CustomParameter argTypeFlag={item.key}/>
      }
      res.push(item_)
      return res
    }, [])
    // 增加空间规格参数
    list.push({
      key: 'SPACE',
      label: '空间规格参数',
      children: <SpaceParameter argTypeFlag={'SPACE'}/>
    })
    setTabList(list)
  }

  return (<SListTabs activeKey={activeKey} onChange={(key) => setActiveKey(key)} auth={false} items={tabList} hideExtra={false}/>);
};

export default ParameterManage;